export const getLabelByProcurementType = (type) => {
    switch (type) {
        case ProcurementType.SMALL:
            return "MFM";
        case ProcurementType.MEDIUM:
            return "PNSPP";
        default:
            return "Non défini";
    }
};

export const getColorByProcurementType = (type) => {
    switch (type) {
        case ProcurementType.SMALL:
            return "green";
        case ProcurementType.MEDIUM:
            return "blue";
        default:
            return "red";
    }
};

export const ProcurementType = {
    SMALL: "SMALL",
    MEDIUM: "MEDIUM",
};
